export default __webpack_public_path__ + "static/media/explore-icon.38d1bd75.svg";